class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    // Remove sticky classes - header should scroll normally
    this.header.classList.remove('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    // Don't add scroll listener - header should scroll with page
    // this.onScrollHandler = this.onScroll.bind(this);
    // this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    // this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    // window.addEventListener('scroll', this.onScrollHandler, false);

    // Don't need observer for sticky behavior
    // this.createObserver();
  }

  setHeaderHeight() {
    const announcementBar = document.querySelector('.announcement-bar-section');
    const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }


  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    // Header scrolls with page - no sticky behavior needed
    // This method is kept for compatibility but does nothing
    return;
  }

  hide() {
    // Don't hide - always keep visible
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    // Always keep visible and sticky
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    // Keep sticky even at top
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    // Details modal removed - function kept for compatibility
    const searchModal = this.header.querySelector('details-modal');
    if (searchModal && typeof searchModal.close === 'function') {
      searchModal.close(false);
    }
  }
}

customElements.define('sticky-header', StickyHeader);

// Theme editor: recalculate announcement-bar-height when sections are added/removed/reordered
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  function recalcAnnouncementBarHeight() {
    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) stickyHeader.setHeaderHeight();
  }
  document.addEventListener('shopify:section:load', recalcAnnouncementBarHeight);
  document.addEventListener('shopify:section:unload', function() {
    // Delay to let DOM update after section removal
    setTimeout(recalcAnnouncementBarHeight, 100);
  });
  document.addEventListener('shopify:section:reorder', recalcAnnouncementBarHeight);
}

// Handle menu and search button clicks
try {
  document.addEventListener('DOMContentLoaded', function() {
    // Remove icons from location text, replace | with → only in header button (not dropdown), and ensure font size matches
  function setLocationText() {
    const locationLinks = document.querySelectorAll('.header__location-link');
    
    locationLinks.forEach(function(locationLink) {
      // Skip if it's the shopping bag button (has cart-icon-bubble id)
      if (locationLink.id === 'cart-icon-bubble') {
        return;
      }
      
      // Find the button, summary, or disclosure link that shows the text (header button only, not dropdown items)
      const clickableElement = locationLink.querySelector('button:not(#cart-icon-bubble):not(.disclosure__link), summary:not(.disclosure__link), .disclosure__button, .localization-form__select');
      
      // Skip if it's inside the dropdown list (dropdown items should keep | separator)
      if (clickableElement && (clickableElement.closest('.disclosure__list-wrapper') || clickableElement.closest('.disclosure__list') || clickableElement.classList.contains('disclosure__link'))) {
        // Don't process dropdown items - they should keep the | separator
        return;
      }
      
      // Also skip if the parent is a disclosure list item
      if (clickableElement && clickableElement.closest('.disclosure__item')) {
        return;
      }
      
      if (clickableElement) {
        // Remove any icons but keep the actual text content (country/currency values)
        const icons = clickableElement.querySelectorAll('svg, .icon-caret, .icon, path');
        icons.forEach(function(icon) {
          icon.remove();
        });
        
        // Only replace vertical line separator (|) with arrow (→) in header button
        // Make sure we're NOT in a dropdown list
        if (!clickableElement.closest('.disclosure__list-wrapper') && 
            !clickableElement.closest('.disclosure__list') &&
            !clickableElement.classList.contains('disclosure__link')) {
          const currentText = clickableElement.textContent || clickableElement.innerText;
          if (currentText && currentText.includes('|')) {
            const newText = currentText.replace(/\s*\|\s*/g, ' → ');
            clickableElement.textContent = newText;
          }
          
          // Also check all child text nodes (but skip if they're in dropdown)
          const walker = document.createTreeWalker(
            clickableElement, 
            NodeFilter.SHOW_TEXT, 
            {
              acceptNode: function(node) {
                // Skip text nodes inside dropdown lists
                if (node.parentElement && (
                  node.parentElement.closest('.disclosure__list-wrapper') || 
                  node.parentElement.closest('.disclosure__list') ||
                  node.parentElement.classList.contains('disclosure__link')
                )) {
                  return NodeFilter.FILTER_REJECT;
                }
                return NodeFilter.FILTER_ACCEPT;
              }
            }, 
            false
          );
          let node;
          while (node = walker.nextNode()) {
            if (node.textContent && node.textContent.includes('|')) {
              node.textContent = node.textContent.replace(/\s*\|\s*/g, ' → ');
            }
          }
        }
        
        // Ensure the element uses the correct font size by applying class/style
        clickableElement.style.fontSize = '';
        if (window.matchMedia('(min-width: 990px)').matches) {
          clickableElement.style.fontSize = '18px';
        } else {
          clickableElement.style.fontSize = '1.4rem';
        }
      }
    });
  }
  
  // Set location text multiple times to catch all cases
  setTimeout(setLocationText, 0);
  setTimeout(setLocationText, 100);
  setTimeout(setLocationText, 300);
  setTimeout(setLocationText, 500);
  
  window.addEventListener('load', function() {
    setTimeout(setLocationText, 0);
    setTimeout(setLocationText, 200);
  });
  
  // Run immediately
  setLocationText();
  
  // Watch for changes to re-apply, but throttle to avoid constant updates
  let locationTextTimeout;
  const locationLinksForObserver = document.querySelectorAll('.header__location-link');
  locationLinksForObserver.forEach(function(locationLink) {
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      mutations.forEach(function(mutation) {
        // Only update if text content actually changed (not just our own changes)
        if ((mutation.type === 'childList' || mutation.type === 'characterData') && 
            mutation.target && 
            !mutation.target.classList.contains('location-text-override')) {
          // Always update if text changes (to catch when user changes country/currency)
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            shouldUpdate = true;
          }
        }
      });
      if (shouldUpdate) {
        clearTimeout(locationTextTimeout);
        locationTextTimeout = setTimeout(setLocationText, 100);
      }
    });
    
    observer.observe(locationLink, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Also listen for changes to select elements
    const select = locationLink.querySelector('select, .select__select, .localization-form__select');
    if (select) {
      select.addEventListener('change', function() {
        setTimeout(setLocationText, 100);
      });
    }
  });
  
  // Position location drawer to extend from button to right edge
  function positionLocationDrawer() {
    const locationLinks = document.querySelectorAll('.header__location-link:not(#cart-icon-bubble)');
    locationLinks.forEach(function(locationLink) {
      const drawer = locationLink.querySelector('.disclosure__list-wrapper, .localization-form .disclosure__list-wrapper');
      if (drawer && locationLink.offsetParent) {
        const rect = locationLink.getBoundingClientRect();
        drawer.style.left = rect.left + 'px';
        drawer.style.right = '0';
        drawer.style.width = 'auto';
      }
    });
  }
  
  // Position drawer when it opens
  document.addEventListener('DOMContentLoaded', function() {
    const locationLinks = document.querySelectorAll('.header__location-link:not(#cart-icon-bubble)');
    locationLinks.forEach(function(locationLink) {
      const details = locationLink.querySelector('details');
      if (details) {
        // Watch for open attribute changes
        const observer = new MutationObserver(function() {
          if (details.hasAttribute('open')) {
            setTimeout(positionLocationDrawer, 10);
          }
        });
        observer.observe(details, { attributes: true, attributeFilter: ['open'] });
        
        // Also position on click
        locationLink.addEventListener('click', function() {
          setTimeout(positionLocationDrawer, 10);
        });
      }
    });
    
    // Initial position
    setTimeout(positionLocationDrawer, 100);
  });
  
  // Reposition on resize
  window.addEventListener('resize', positionLocationDrawer);
  
  // Ensure grid layout is maintained - logo is independent via CSS Grid
  function maintainGridLayout() {
    const headerInner = document.querySelector('.header__inner');
    const headerHeading = document.querySelector('.header__heading');
    const header = document.querySelector('.header');
    const headerWrapper = document.querySelector('.header-wrapper');
    
    // Ensure grid layout is applied
    if (headerInner) {
      headerInner.style.display = 'grid';
      headerInner.style.gridTemplateColumns = '1fr auto 1fr';
      headerInner.style.width = '100%';
      headerInner.style.maxWidth = '100%';
      headerInner.style.alignItems = 'center';
    }
    
    // Ensure logo is in center column and remove any positioning
    if (headerHeading) {
      headerHeading.style.gridColumn = '2';
      headerHeading.style.justifySelf = 'center';
      headerHeading.style.position = 'relative';
      headerHeading.style.left = 'auto';
      headerHeading.style.right = 'auto';
      headerHeading.style.transform = 'none';
    }
    
    // Ensure header and wrapper are full width
    if (header) {
      header.style.maxWidth = '100%';
      header.style.width = '100%';
    }
    if (headerWrapper) {
      headerWrapper.style.maxWidth = '100%';
      headerWrapper.style.width = '100%';
    }
  }
  
  // Maintain grid layout immediately
  maintainGridLayout();
  
  // Re-apply after delays to catch late-applied styles
  setTimeout(maintainGridLayout, 0);
  setTimeout(maintainGridLayout, 100);
  setTimeout(maintainGridLayout, 300);
  
  
  
  // Also on window load
  window.addEventListener('load', function() {
    maintainGridLayout();
    setTimeout(maintainGridLayout, 100);
  });
  
  // Watch for style changes and re-apply grid layout
  const headerInner = document.querySelector('.header__inner');
  const headerHeading = document.querySelector('.header__heading');
  
  if (headerInner) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          setTimeout(maintainGridLayout, 0);
        }
      });
    });
    
    observer.observe(headerInner, { 
      attributes: true, 
      attributeFilter: ['style', 'class'] 
    });
  }
  
  if (headerHeading) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          setTimeout(maintainGridLayout, 0);
        }
      });
    });
    
    observer.observe(headerHeading, { 
      attributes: true, 
      attributeFilter: ['style', 'class'] 
    });
  }
  
  // Watch for sticky header class changes to maintain grid layout
  const sectionHeader = document.querySelector('.section-header');
  if (sectionHeader) {
    const stickyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // Re-apply grid layout when sticky classes change
          setTimeout(maintainGridLayout, 0);
          setTimeout(setExactHeaderHeight, 0);
        }
      });
    });
    
    stickyObserver.observe(sectionHeader, { 
      attributes: true, 
      attributeFilter: ['class'] 
    });
  }
  
  // Also watch for scroll events to maintain grid during sticky transitions
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      maintainGridLayout();
    }, 50);
  }, { passive: true });
  
  // Menu button toggle
  const menuButton = document.getElementById('MenuToggleButton');
  const menuButtonText = menuButton ? menuButton.querySelector('.menu-button-text') : null;

  // iOS/Safari: vh is unreliable (layout vs visual viewport). Use pixel height so submenu isn't clipped.
  function getMobileDrawerHeightPx() {
    var h = window.innerHeight;
    if (typeof window.visualViewport !== 'undefined' && window.visualViewport.height > 0) {
      h = window.visualViewport.height;
    }
    return Math.round(h * 0.75) + 'px';
  }

  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  // Try to find drawer - use multiple selectors for reliability
  let menuDrawer = document.querySelector('header-drawer');
  if (!menuDrawer) {
    // Fallback: try to find by ID
    const drawerContainer = document.getElementById('Details-menu-drawer-container');
    if (drawerContainer) {
      menuDrawer = drawerContainer.closest('header-drawer');
    }
  }
  
  if (menuButton) {
    // Function to update button text based on drawer state
    function updateMenuButtonText() {
      if (menuButtonText) {
        // Re-find drawer if needed
        if (!menuDrawer) {
          menuDrawer = document.querySelector('header-drawer');
          if (!menuDrawer) {
            const drawerContainer = document.getElementById('Details-menu-drawer-container');
            if (drawerContainer) {
              menuDrawer = drawerContainer.closest('header-drawer');
            }
          }
        }
        
        const drawerDetails = menuDrawer ? menuDrawer.querySelector('details, #Details-menu-drawer-container') : document.getElementById('Details-menu-drawer-container');
        const isOpen = (menuDrawer && menuDrawer.hasAttribute('open')) || 
                      (drawerDetails && drawerDetails.hasAttribute('open')) ||
                      (menuDrawer && menuDrawer.classList.contains('menu-opening'));
        menuButtonText.textContent = isOpen ? 'Close' : 'Menu';
        menuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        
        // Add/remove class to body for CSS targeting
        if (window.matchMedia('(max-width: 750px)').matches) {
          if (isOpen) {
            document.body.classList.add('menu-drawer-open');
          } else {
            document.body.classList.remove('menu-drawer-open');
          }
        }
        
        // Hide/show Search button when Menu is open/closed
        const searchButton = document.querySelector('[data-hide-when-menu-open]');
        if (searchButton) {
          if (isOpen) {
            searchButton.classList.add('hide-when-menu-open');
          } else {
            searchButton.classList.remove('hide-when-menu-open');
          }
        }
        
        // Mobile only: Hide/show Shopping bag text when Menu is open/closed
        if (window.matchMedia('(max-width: 750px)').matches) {
          const cartButtonText = document.querySelector('#cart-icon-bubble .cart-button-text');
          if (cartButtonText) {
            if (isOpen) {
              cartButtonText.classList.add('hide-when-menu-open');
            } else {
              cartButtonText.classList.remove('hide-when-menu-open');
            }
          }
        }
        
        // Logo positioning is handled by CSS - just ensure inline styles don't interfere
        const headerHeading = document.querySelector('.header__heading');
        if (headerHeading && window.matchMedia('(max-width: 750px)').matches) {
          if (isOpen) {
            // Remove any inline marginTop that might interfere with CSS positioning
            headerHeading.style.marginTop = '';
          } else {
            // Reset to default when menu closes
            headerHeading.style.marginTop = '';
          }
        }
      }
    }
    
    // Helper function to close all open submenus
    function closeAllSubmenus() {
      const allSubmenuDetails = menuDrawer.querySelectorAll('.menu-drawer__submenu details[open], .menu-drawer__navigation details[open], .menu-drawer__menu details[open]');
      allSubmenuDetails.forEach(function(submenuDetails) {
        submenuDetails.removeAttribute('open');
      });
    }
    
    // Initial state
    updateMenuButtonText();
    
    // Toggle drawer on button click
    menuButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Re-find drawer in case it wasn't available initially
      if (!menuDrawer) {
        menuDrawer = document.querySelector('header-drawer');
        if (!menuDrawer) {
          const drawerContainer = document.getElementById('Details-menu-drawer-container');
          if (drawerContainer) {
            menuDrawer = drawerContainer.closest('header-drawer');
          }
        }
      }
      
      // Find drawer details - try multiple methods
      let drawerDetails = null;
      let summary = null;
      
      if (menuDrawer) {
        drawerDetails = menuDrawer.querySelector('details, #Details-menu-drawer-container');
        summary = menuDrawer.querySelector('summary');
      } else {
        // Fallback: find directly by ID
        drawerDetails = document.getElementById('Details-menu-drawer-container');
        if (drawerDetails) {
          summary = drawerDetails.querySelector('summary');
          menuDrawer = drawerDetails.closest('header-drawer');
        }
      }
      
      if (drawerDetails) {
        const isCurrentlyOpen = drawerDetails.hasAttribute('open');
        
        if (isCurrentlyOpen) {
          // Close all submenus first
          closeAllSubmenus();
          
          // Mobile only: Show shopping bag text immediately when closing menu
          if (window.matchMedia('(max-width: 750px)').matches) {
            const cartButtonText = document.querySelector('#cart-icon-bubble .cart-button-text');
            if (cartButtonText) {
              cartButtonText.classList.remove('hide-when-menu-open');
            }
          }
          
          // Add closing animation class for backdrop
          const backdrop = document.querySelector('.drawer-backdrop');
          if (backdrop && window.matchMedia('(max-width: 750px)').matches) {
            backdrop.classList.add('menu-closing');
          }
          
          // Get the actual animation duration from CSS variable
          const duration = getComputedStyle(document.documentElement)
            .getPropertyValue('--duration-default')
            .trim() || '0.3s';
          const durationMs = parseFloat(duration) * 1000;
          
          // Add closing class to header-drawer for animation
          menuDrawer.classList.add('menu-closing');
          
          // Close the drawer after animation
          setTimeout(function() {
            if (typeof menuDrawer.close === 'function') {
              menuDrawer.close();
            } else {
              drawerDetails.removeAttribute('open');
              menuDrawer.removeAttribute('open');
              menuDrawer.classList.remove('menu-drawer-open');
            }
            
            // Remove closing classes
            menuDrawer.classList.remove('menu-closing');
            if (backdrop) {
              backdrop.classList.remove('menu-closing');
            }
          }, durationMs);
        } else {
          // Close search drawer if open
          const searchDrawer = document.getElementById('SearchDrawer');
          if (searchDrawer && searchDrawer.hasAttribute('open')) {
            searchDrawer.removeAttribute('open');
            const searchButtonText = document.querySelector('.search-button-text');
            if (searchButtonText) {
              searchButtonText.textContent = 'Search';
            }
          }
          
          // Close location drawer if open
          const locationLinks = document.querySelectorAll('.header__location-link');
          locationLinks.forEach(function(locationLink) {
            const locationDetails = locationLink.querySelector('details[open], .localization-form details[open], localization-form details[open]');
            if (locationDetails && locationDetails.hasAttribute('open')) {
              locationDetails.removeAttribute('open');
            }
          });
          
          // Mobile only: Hide shopping bag text immediately when opening menu
          if (window.matchMedia('(max-width: 750px)').matches) {
            const cartButtonText = document.querySelector('#cart-icon-bubble .cart-button-text');
            if (cartButtonText) {
              cartButtonText.classList.add('hide-when-menu-open');
            }
          }
          
          // Open the drawer - try multiple methods
          if (typeof menuDrawer.open === 'function') {
            menuDrawer.open();
            // CRITICAL: Force proper dimensions on mobile after opening
            if (window.matchMedia('(max-width: 750px)').matches) {
              setTimeout(function() {
                menuDrawer.style.display = 'block';
                menuDrawer.style.position = 'fixed';
                menuDrawer.style.width = '100%';
                // iOS: vh is unreliable and clips submenu; use pixel height from visual viewport
                if (isIOS()) {
                  var h = getMobileDrawerHeightPx();
                  menuDrawer.style.height = h;
                  menuDrawer.style.minHeight = h;
                  menuDrawer.style.maxHeight = h;
                } else {
                  menuDrawer.style.height = '75vh';
                  menuDrawer.style.minHeight = '75vh';
                  menuDrawer.style.maxHeight = '75vh';
                }
                menuDrawer.style.top = '0';
                menuDrawer.style.left = '0';
                menuDrawer.style.right = '0';
                menuDrawer.style.visibility = 'visible';
                menuDrawer.style.opacity = '1';
                menuDrawer.style.zIndex = '1003'; /* Must be above header (1003) */
              }, 10);
            }
          } else if (summary) {
            // Temporarily make summary clickable and click it
            const originalStyle = summary.style.cssText;
            summary.style.position = 'fixed';
            summary.style.top = '0';
            summary.style.left = '0';
            summary.style.width = '1px';
            summary.style.height = '1px';
            summary.style.opacity = '0';
            summary.style.pointerEvents = 'auto';
            summary.style.zIndex = '9999';
            summary.click();
            summary.style.cssText = originalStyle;
            // CRITICAL: Force proper dimensions on mobile after clicking
            if (window.matchMedia('(max-width: 750px)').matches) {
              setTimeout(function() {
                menuDrawer.style.display = 'block';
                menuDrawer.style.position = 'fixed';
                menuDrawer.style.width = '100%';
                if (isIOS()) {
                  var h = getMobileDrawerHeightPx();
                  menuDrawer.style.height = h;
                  menuDrawer.style.minHeight = h;
                  menuDrawer.style.maxHeight = h;
                } else {
                  menuDrawer.style.height = '75vh';
                  menuDrawer.style.minHeight = '75vh';
                  menuDrawer.style.maxHeight = '75vh';
                }
                menuDrawer.style.top = '0';
                menuDrawer.style.left = '0';
                menuDrawer.style.right = '0';
                menuDrawer.style.visibility = 'visible';
                menuDrawer.style.opacity = '1';
                menuDrawer.style.zIndex = '1003'; /* Must be above header (1003) */
              }, 10);
            }
          } else {
            // Manually set open attribute
            drawerDetails.setAttribute('open', '');
            menuDrawer.setAttribute('open', '');
            // Add class to ensure CSS can target it
            menuDrawer.classList.add('menu-drawer-open');
            // CRITICAL: Force proper dimensions on mobile
            if (window.matchMedia('(max-width: 750px)').matches) {
              menuDrawer.style.display = 'block';
              menuDrawer.style.position = 'fixed';
              menuDrawer.style.width = '100%';
              if (isIOS()) {
                var h = getMobileDrawerHeightPx();
                menuDrawer.style.height = h;
                menuDrawer.style.minHeight = h;
                menuDrawer.style.maxHeight = h;
              } else {
                menuDrawer.style.height = '75vh';
                menuDrawer.style.minHeight = '75vh';
                menuDrawer.style.maxHeight = '75vh';
              }
              menuDrawer.style.top = '0';
              menuDrawer.style.left = '0';
              menuDrawer.style.right = '0';
              menuDrawer.style.visibility = 'visible';
              menuDrawer.style.opacity = '1';
              menuDrawer.style.zIndex = '1002';
            }
          }
        }
        
        // Update button text immediately and again after delay to catch any async changes
        updateMenuButtonText();
        setTimeout(updateMenuButtonText, 100);
        setTimeout(updateMenuButtonText, 200);
      } else if (menuDrawer && typeof menuDrawer.open === 'function') {
        // Use component methods if available
        const isOpen = menuDrawer.hasAttribute('open');
        if (isOpen) {
          // Close all submenus first
          closeAllSubmenus();
          
          // Mobile only: Show shopping bag text immediately when closing menu
          if (window.matchMedia('(max-width: 750px)').matches) {
            const cartButtonText = document.querySelector('#cart-icon-bubble .cart-button-text');
            if (cartButtonText) {
              cartButtonText.classList.remove('hide-when-menu-open');
            }
          }
          
          menuDrawer.close();
        } else {
          // Mobile only: Hide shopping bag text immediately when opening menu
          if (window.matchMedia('(max-width: 750px)').matches) {
            const cartButtonText = document.querySelector('#cart-icon-bubble .cart-button-text');
            if (cartButtonText) {
              cartButtonText.classList.add('hide-when-menu-open');
            }
          }
          
          menuDrawer.open();
          // Add class to ensure CSS can target it
          if (menuDrawer) {
            menuDrawer.classList.add('menu-drawer-open');
            // CRITICAL: Force proper dimensions on mobile after opening
            if (window.matchMedia('(max-width: 750px)').matches) {
              setTimeout(function() {
                menuDrawer.style.display = 'block';
                menuDrawer.style.position = 'fixed';
                menuDrawer.style.width = '100%';
                if (isIOS()) {
                  var h = getMobileDrawerHeightPx();
                  menuDrawer.style.height = h;
                  menuDrawer.style.minHeight = h;
                  menuDrawer.style.maxHeight = h;
                } else {
                  menuDrawer.style.height = '75vh';
                  menuDrawer.style.minHeight = '75vh';
                  menuDrawer.style.maxHeight = '75vh';
                }
                menuDrawer.style.top = '0';
                menuDrawer.style.left = '0';
                menuDrawer.style.right = '0';
                menuDrawer.style.visibility = 'visible';
                menuDrawer.style.opacity = '1';
                menuDrawer.style.zIndex = '1003'; /* Must be above header (1003) */
              }, 10);
            }
          }
        }
        // Update button text immediately and again after delay to catch any async changes
        updateMenuButtonText();
        setTimeout(updateMenuButtonText, 100);
        setTimeout(updateMenuButtonText, 200);
      } else {
        // Last resort: try to find and open drawer directly
        console.warn('Menu drawer not found, attempting direct access');
        const fallbackDrawer = document.getElementById('Details-menu-drawer-container');
        if (fallbackDrawer) {
          const isOpen = fallbackDrawer.hasAttribute('open');
          if (isOpen) {
            fallbackDrawer.removeAttribute('open');
            if (menuButtonText) menuButtonText.textContent = 'Menu';
            document.body.classList.remove('menu-drawer-open');
          } else {
            fallbackDrawer.setAttribute('open', '');
            if (menuButtonText) menuButtonText.textContent = 'Close';
            if (window.matchMedia('(max-width: 750px)').matches) {
              document.body.classList.add('menu-drawer-open');
            }
          }
        }
      }
    });
    
    // Get drawer details for observer - re-find in case it wasn't available initially
    if (!menuDrawer) {
      menuDrawer = document.querySelector('header-drawer');
      if (!menuDrawer) {
        const drawerContainer = document.getElementById('Details-menu-drawer-container');
        if (drawerContainer) {
          menuDrawer = drawerContainer.closest('header-drawer');
        }
      }
    }
    
    const drawerDetails = menuDrawer ? menuDrawer.querySelector('details, #Details-menu-drawer-container') : document.getElementById('Details-menu-drawer-container');
    
    // Watch for drawer state changes (when closed by other means)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          updateMenuButtonText();
        }
      });
    });
    
    // Observe both the drawer and its details element
    observer.observe(menuDrawer, { attributes: true, attributeFilter: ['open'] });
    if (drawerDetails) {
      observer.observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
    }
    
    // Also listen for click events on the drawer's close button if it exists
    const closeButton = menuDrawer.querySelector('[aria-label*="close" i], .menu-drawer__close-button, button[aria-label*="Close" i], a[aria-label*="Close" i]');
    if (closeButton) {
      closeButton.addEventListener('click', function() {
        setTimeout(updateMenuButtonText, 100);
      });
    }
    
    // Listen for any close events
    menuDrawer.addEventListener('close', function() {
      closeAllSubmenus();
      updateMenuButtonText();
    });
    
    // Also check on any click within the drawer (for close buttons)
    menuDrawer.addEventListener('click', function(e) {
      const target = e.target;
      if (target.closest('.menu-drawer__close-button') || 
          target.closest('[aria-label*="close" i]') ||
          target.textContent.trim().toLowerCase() === 'close') {
        setTimeout(updateMenuButtonText, 100);
      }
    });

    // iOS: when visual viewport changes (address bar, keyboard), update drawer height so submenu stays usable
    if (isIOS() && typeof window.visualViewport !== 'undefined') {
      function refreshDrawerHeightOnResize() {
        if (!menuDrawer || !menuDrawer.hasAttribute('open')) return;
        var details = menuDrawer.querySelector('details, #Details-menu-drawer-container');
        if (!details || !details.hasAttribute('open')) return;
        if (window.matchMedia('(max-width: 750px)').matches) {
          var h = getMobileDrawerHeightPx();
          menuDrawer.style.height = h;
          menuDrawer.style.minHeight = h;
          menuDrawer.style.maxHeight = h;
        }
      }
      window.visualViewport.addEventListener('resize', refreshDrawerHeightOnResize);
      window.visualViewport.addEventListener('scroll', refreshDrawerHeightOnResize);
    }
  }

  // Search button toggle
  const searchButton = document.getElementById('SearchButton');
  const searchButtonText = searchButton ? searchButton.querySelector('.search-button-text') : null;
  const searchDrawer = document.getElementById('SearchDrawer');
  
  if (searchButton && searchDrawer) {
    // Function to update button text based on drawer state
    function updateSearchButtonText() {
      if (searchButtonText) {
        const isOpen = searchDrawer.hasAttribute('open');
        searchButtonText.textContent = isOpen ? 'Close' : 'Search';
        searchButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        
        // Add/remove class to header for positioning
        const header = document.querySelector('.header');
        if (header) {
          if (isOpen) {
            header.classList.add('search-drawer-open');
          } else {
            header.classList.remove('search-drawer-open');
          }
        }
        
        // Hide/show Menu button when Search is open/closed
        const menuButtonToHide = document.querySelector('[data-hide-when-search-open]');
        if (menuButtonToHide) {
          if (isOpen) {
            menuButtonToHide.classList.add('hide-when-search-open');
          } else {
            menuButtonToHide.classList.remove('hide-when-search-open');
          }
        }
      }
    }
    
    // Initial state
    updateSearchButtonText();
    
    // Toggle drawer on button click
    searchButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isCurrentlyOpen = searchDrawer.hasAttribute('open');
      
      if (isCurrentlyOpen) {
        // Close the drawer
        searchDrawer.removeAttribute('open');
        updateSearchButtonText();
      } else {
        // Update button text immediately before opening
        if (searchButtonText) {
          searchButtonText.textContent = 'Close';
          searchButton.setAttribute('aria-expanded', 'true');
        }
        
        // Close menu drawer if open
        if (menuDrawer) {
          const drawerDetails = menuDrawer.querySelector('details');
          if (drawerDetails && drawerDetails.hasAttribute('open')) {
            // Close all submenus first
            const allSubmenuDetails = menuDrawer.querySelectorAll('.menu-drawer__submenu details[open], .menu-drawer__navigation details[open], .menu-drawer__menu details[open]');
            allSubmenuDetails.forEach(function(submenuDetails) {
              submenuDetails.removeAttribute('open');
            });
            
            if (typeof menuDrawer.close === 'function') {
              menuDrawer.close();
            } else {
              drawerDetails.removeAttribute('open');
              menuDrawer.removeAttribute('open');
            }
            const menuButtonText = document.querySelector('.menu-button-text');
            if (menuButtonText) {
              menuButtonText.textContent = 'Menu';
            }
          }
        }
        
        // Close location drawer if open
        const locationLinks = document.querySelectorAll('.header__location-link');
        locationLinks.forEach(function(locationLink) {
          const locationDetails = locationLink.querySelector('details[open], .localization-form details[open], localization-form details[open]');
          if (locationDetails && locationDetails.hasAttribute('open')) {
            locationDetails.removeAttribute('open');
          }
        });
        
        // Open the drawer
        searchDrawer.setAttribute('open', '');
        
        // Don't auto-focus - let user click first
      }
    });
    
    // Watch for drawer state changes
    const searchObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          updateSearchButtonText();
        }
      });
    });
    
    searchObserver.observe(searchDrawer, { attributes: true, attributeFilter: ['open'] });
  }
  
  // Location drawer - ensure it's closed on load and handle mutual exclusivity
  const locationLinks = document.querySelectorAll('.header__location-link');
  locationLinks.forEach(function(locationLink) {
    // Close location drawer on page load
    const locationDetails = locationLink.querySelector('details, .disclosure-has-popup, .localization-form details, .localization-form .disclosure-has-popup');
    if (locationDetails && locationDetails.hasAttribute('open')) {
      locationDetails.removeAttribute('open');
    }
    
    // Watch for changes to close other drawers when location opens
    if (locationDetails) {
      const locationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            const isOpen = locationDetails.hasAttribute('open');
            
            if (isOpen) {
              // Close menu drawer if open
              if (menuDrawer) {
                const drawerDetails = menuDrawer.querySelector('details');
                if (drawerDetails && drawerDetails.hasAttribute('open')) {
                  // Close all submenus first
                  const allSubmenuDetails = menuDrawer.querySelectorAll('.menu-drawer__submenu details[open], .menu-drawer__navigation details[open], .menu-drawer__menu details[open]');
                  allSubmenuDetails.forEach(function(submenuDetails) {
                    submenuDetails.removeAttribute('open');
                  });
                  
                  if (typeof menuDrawer.close === 'function') {
                    menuDrawer.close();
                  } else {
                    drawerDetails.removeAttribute('open');
                    menuDrawer.removeAttribute('open');
                  }
                  const menuButtonText = document.querySelector('.menu-button-text');
                  if (menuButtonText) {
                    menuButtonText.textContent = 'Menu';
                  }
                }
              }
              
              // Close search drawer if open
              const searchDrawer = document.getElementById('SearchDrawer');
              if (searchDrawer && searchDrawer.hasAttribute('open')) {
                searchDrawer.removeAttribute('open');
                const searchButtonText = document.querySelector('.search-button-text');
                if (searchButtonText) {
                  searchButtonText.textContent = 'Search';
                }
              }
            }
          }
        });
      });
      
      locationObserver.observe(locationDetails, { 
        attributes: true, 
        attributeFilter: ['open'] 
      });
    }
    
    // Prevent autofocus on location form inputs - match search drawer behavior
    if (locationDetails) {
      let drawerOpenTime = 0;
      let autoFocusBlocked = true;
      
      const blurAllLocationInputs = function() {
        const locationInputsAll = locationLink.querySelectorAll('input, .field__input, .country-filter input, .country-filter__input');
        locationInputsAll.forEach(function(input) {
          if (document.activeElement === input) {
            input.blur();
          }
        });
      };
      
      const preventLocationAutofocus = function() {
        // Remove autofocus attribute from any inputs in the location form
        const locationInputs = locationLink.querySelectorAll('input[autofocus], .field__input[autofocus], .country-filter input[autofocus], .country-filter__input[autofocus]');
        locationInputs.forEach(function(input) {
          input.removeAttribute('autofocus');
        });
        
        // Prevent any automatic focus() calls on location inputs and blur if already focused
        const locationInputsAll = locationLink.querySelectorAll('input, .field__input, .country-filter input, .country-filter__input');
        locationInputsAll.forEach(function(input) {
          // Remove autofocus attribute if present
          input.removeAttribute('autofocus');
          
          // Blur the input if it's currently focused (auto-focused)
          if (document.activeElement === input) {
            input.blur();
          }
          
          // Override focus() method to prevent auto-focus
          if (!input._locationFocusOverridden) {
            input._locationFocusOverridden = true;
            const originalFocus = input.focus.bind(input);
            input.focus = function() {
              const timeSinceOpen = Date.now() - drawerOpenTime;
              // Block focus if within 500ms of drawer opening (auto-focus)
              if (autoFocusBlocked && timeSinceOpen < 500) {
                return; // Don't focus
              }
              // Otherwise allow normal focus (user clicked)
              return originalFocus.apply(this, arguments);
            };
          }
          
          // Add focus event listener to blur if focused too soon after drawer opens (auto-focus)
          if (!input._locationFocusListenerAdded) {
            input._locationFocusListenerAdded = true;
            input.addEventListener('focus', function(e) {
              const timeSinceOpen = Date.now() - drawerOpenTime;
              // If focused within 500ms of drawer opening, it's likely auto-focus - blur it immediately
              if (autoFocusBlocked && timeSinceOpen < 500) {
                e.target.blur();
              }
            }, true); // Use capture phase to intercept before other handlers
          }
        });
      };
      
      // Run immediately and when location drawer opens
      preventLocationAutofocus();
      
      const locationOpenObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (locationDetails.hasAttribute('open')) {
              drawerOpenTime = Date.now();
              autoFocusBlocked = true;
              // Immediately blur any focused inputs
              blurAllLocationInputs();
              // Run immediately to catch inputs that exist
              preventLocationAutofocus();
              // Delay slightly to catch inputs that are added dynamically
              setTimeout(function() {
                blurAllLocationInputs();
                preventLocationAutofocus();
              }, 0);
              setTimeout(function() {
                blurAllLocationInputs();
                preventLocationAutofocus();
              }, 10);
              setTimeout(function() {
                blurAllLocationInputs();
                preventLocationAutofocus();
              }, 50);
              setTimeout(function() {
                blurAllLocationInputs();
                preventLocationAutofocus();
              }, 100);
              setTimeout(function() {
                blurAllLocationInputs();
                preventLocationAutofocus();
              }, 200);
              // Allow focus after 500ms (user can click after this)
              setTimeout(function() {
                autoFocusBlocked = false;
              }, 500);
            } else {
              // Reset when drawer closes
              autoFocusBlocked = true;
              const locationInputsAll = locationLink.querySelectorAll('input, .field__input, .country-filter input, .country-filter__input');
              locationInputsAll.forEach(function(input) {
                input._locationFocusBlocked = false;
                // Restore original focus method
                if (input._locationFocusOverridden) {
                  // The override will still work, but we'll reset the flag
                  input._locationFocusOverridden = false;
                }
              });
            }
          }
        });
      });
      
      locationOpenObserver.observe(locationDetails, { 
        attributes: true, 
        attributeFilter: ['open'],
        childList: true,
        subtree: true
      });
    }
  });
  
  // Close drawers when clicking outside
  document.addEventListener('click', function(e) {
    // Check if click is outside menu drawer
    if (menuDrawer) {
      const drawerDetails = menuDrawer.querySelector('details');
      const isMenuOpen = (drawerDetails && drawerDetails.hasAttribute('open')) || menuDrawer.hasAttribute('open');
      
      if (isMenuOpen) {
        const menuButton = document.getElementById('MenuToggleButton');
        const isClickInsideMenu = menuDrawer.contains(e.target) || (menuButton && menuButton.contains(e.target));
        
        if (!isClickInsideMenu) {
          // Get the actual animation duration from CSS variable
          const duration = getComputedStyle(document.documentElement)
            .getPropertyValue('--duration-default')
            .trim() || '0.3s';
          
          // Convert to milliseconds
          const durationMs = parseFloat(duration) * 1000;
          
          // Add closing classes for animation
          menuDrawer.classList.add('menu-closing');
          const backdrop = document.querySelector('.drawer-backdrop');
          if (backdrop && window.matchMedia('(max-width: 750px)').matches) {
            backdrop.classList.add('menu-closing');
          }
          
          // Wait for animation to complete, then close
          setTimeout(function() {
            // Close all submenus first
            closeAllSubmenus();
            
            // Mobile only: Show shopping bag text immediately when closing menu
            if (window.matchMedia('(max-width: 750px)').matches) {
              const cartButtonText = document.querySelector('#cart-icon-bubble .cart-button-text');
              if (cartButtonText) {
                cartButtonText.classList.remove('hide-when-menu-open');
              }
            }
            
            if (typeof menuDrawer.close === 'function') {
              menuDrawer.close();
            } else if (drawerDetails) {
              drawerDetails.removeAttribute('open');
              menuDrawer.removeAttribute('open');
            }
            
            // Remove closing classes after a brief delay
            setTimeout(function() {
              menuDrawer.classList.remove('menu-closing');
              if (backdrop) {
                backdrop.classList.remove('menu-closing');
              }
            }, 50);
            
            const menuButtonText = document.querySelector('.menu-button-text');
            if (menuButtonText) {
              menuButtonText.textContent = 'Menu';
            }
            
            // Show Search button again
            const searchButtonToShow = document.querySelector('[data-hide-when-menu-open]');
            if (searchButtonToShow) {
              searchButtonToShow.classList.remove('hide-when-menu-open');
            }
            
            // Update button text to ensure shopping bag is shown
            updateMenuButtonText();
          }, durationMs); // Match animation duration from CSS variable
        }
      }
    }
    
    // Check if click is outside search drawer
    if (searchDrawer && searchDrawer.hasAttribute('open')) {
      const isClickInsideSearch = searchDrawer.contains(e.target) || (searchButton && searchButton.contains(e.target));
      
      if (!isClickInsideSearch) {
        searchDrawer.removeAttribute('open');
        const searchButtonText = document.querySelector('.search-button-text');
        if (searchButtonText) {
          searchButtonText.textContent = 'Search';
        }
        
        // Show Menu button again
        const menuButtonToShow = document.querySelector('[data-hide-when-search-open]');
        if (menuButtonToShow) {
          menuButtonToShow.classList.remove('hide-when-search-open');
        }
        
        // Remove positioning class
        const header = document.querySelector('.header');
        if (header) {
          header.classList.remove('search-drawer-open');
        }
      }
    }
    
    // Check if click is outside location drawer
    const locationLinks = document.querySelectorAll('.header__location-link');
    locationLinks.forEach(function(locationLink) {
      const locationDetails = locationLink.querySelector('details[open], .localization-form details[open], localization-form details[open]');
      if (locationDetails && locationDetails.hasAttribute('open')) {
        const isClickInsideLocation = locationLink.contains(e.target);
        
        if (!isClickInsideLocation) {
          locationDetails.removeAttribute('open');
        }
      }
    });
  });
  
  // Store the base header height to prevent header shifting when elements are hidden
  let baseHeaderHeight = null;
  
  function getBaseHeaderHeight() {
    if (baseHeaderHeight === null) {
      const header = document.querySelector('.header');
      if (header) {
        baseHeaderHeight = header.offsetHeight;
      }
    }
    return baseHeaderHeight || 100; // fallback to 100px
  }
  
  // Position cart drawer below fixed header
  function positionCartDrawer(shouldRecalculateHeight) {
    const header = document.querySelector('.header');
    const headerWrapper = document.querySelector('.header-wrapper');
    const cartDrawer = document.querySelector('cart-drawer');
    const cartDrawerInner = document.querySelector('.drawer__inner, .drawer__inner-empty');
    
    if (header && cartDrawer && cartDrawerInner) {
      let headerHeight;
      
      // Only recalculate header height on initial load or resize, not when cart opens/closes
      if (shouldRecalculateHeight) {
        headerHeight = header.offsetHeight;
        baseHeaderHeight = headerHeight;
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      } else {
        // Use stored base height to prevent header shifting
        headerHeight = getBaseHeaderHeight();
      }
      
      // Check if mobile (viewport width <= 750px)
      const isMobile = window.innerWidth <= 750;
      
      if (isMobile) {
        // Mobile: Position at top to blend with header, full width, no background to blend
        if (headerWrapper) {
          cartDrawer.style.position = 'fixed';
          cartDrawer.style.top = '0'; // Start at top to blend with header
          cartDrawer.style.left = '0';
          cartDrawer.style.right = '0';
          cartDrawer.style.width = '100%';
          cartDrawer.style.height = (window.innerHeight * 0.9) + 'px'; // Full 90vh height
          cartDrawer.style.maxHeight = (window.innerHeight * 0.9) + 'px';
          cartDrawer.style.zIndex = '999'; // Below header
          cartDrawer.style.borderRadius = '0 0 40px 40px';
          cartDrawer.style.background = 'transparent'; // No background to blend with header
        }
        
        cartDrawerInner.style.top = '0';
        cartDrawerInner.style.width = '100%';
        cartDrawerInner.style.maxWidth = '100%';
        cartDrawerInner.style.height = '100%';
        cartDrawerInner.style.maxHeight = '100%';
        // Padding will be handled by CSS
      } else {
        // Desktop: Position cart drawer below fixed header (announcement bar + header) - use negative offset to blend perfectly
        const announcementBar = document.querySelector('.announcement-bar-section');
        const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
        const totalTop = announcementBarHeight + headerHeight - 1;
        if (headerWrapper) {
          cartDrawer.style.position = 'fixed';
          cartDrawer.style.top = totalTop + 'px';
          cartDrawer.style.right = '0';
          cartDrawer.style.zIndex = '999';
        }
        
        cartDrawerInner.style.top = '0';
        // Only set max-height if cart is not empty
        if (!cartDrawer.classList.contains('is-empty')) {
          cartDrawerInner.style.height = '75vh';
          cartDrawerInner.style.maxHeight = '75vh';
        } else {
          cartDrawerInner.style.maxHeight = '500px';
          cartDrawerInner.style.height = '500px';
        }
      }
    }
  }
  
  // Position on load - recalculate height
  positionCartDrawer(true);
  
  // Reposition on resize - recalculate height
  window.addEventListener('resize', function() {
    baseHeaderHeight = null; // Reset cached height on resize
    positionCartDrawer(true);
  });
  
  // Ensure cart drawer logo is always present (in case AJAX updates remove it)
  function ensureCartDrawerLogo() {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartDrawerInner = document.getElementById('CartDrawer');
    if (cartDrawer && cartDrawerInner) {
      let logo = document.getElementById('CartDrawer-Logo');
      if (!logo) {
        // Logo is missing, create it from header logo
        const headerLogo = document.querySelector('.header__heading-logo');
        if (headerLogo) {
          logo = document.createElement('div');
          logo.className = 'cart-drawer__logo';
          logo.id = 'CartDrawer-Logo';
          const logoLink = document.createElement('a');
          logoLink.href = '/';
          logoLink.className = 'cart-drawer__logo-link link link--text focus-inset';
          const logoWrapper = document.createElement('div');
          logoWrapper.className = 'cart-drawer__logo-wrapper';
          const logoImg = headerLogo.cloneNode(true);
          logoImg.className = 'cart-drawer__logo-image';
          logoWrapper.appendChild(logoImg);
          logoLink.appendChild(logoWrapper);
          logo.appendChild(logoLink);
          cartDrawerInner.appendChild(logo);
        }
      }
    }
  }

  // Manage Account/Location visibility when cart opens/closes
  function updateAccountLocationVisibility() {
    const accountLink = document.querySelector('.header__right-nav .header__nav-link:not(#cart-icon-bubble)');
    const locationLinks = document.querySelectorAll('.header__location-link:not(#cart-icon-bubble)');
    
    // Check if cart drawer is open by checking drawer inner visibility
    const isCartOpen = isCartDrawerOpen();
    
    // Ensure logo is present
    ensureCartDrawerLogo();
    // Update Account link
    if (accountLink) {
      if (isCartOpen) {
        accountLink.classList.add('hide-when-cart-open');
      } else {
        accountLink.classList.remove('hide-when-cart-open');
      }
    }
    
    // Update Location links
    locationLinks.forEach(function(link) {
      if (link && link.id !== 'cart-icon-bubble') {
        if (isCartOpen) {
          link.classList.add('hide-when-cart-open');
        } else {
          link.classList.remove('hide-when-cart-open');
        }
      }
    });
    
    // Mobile only: Hide/show Menu button when Cart is open/closed
    if (window.matchMedia('(max-width: 750px)').matches) {
      const menuButton = document.getElementById('MenuToggleButton');
      if (menuButton) {
        if (isCartOpen) {
          menuButton.classList.add('hide-when-cart-open');
        } else {
          menuButton.classList.remove('hide-when-cart-open');
        }
      }
    }
  }
  
  // Initial state - remove hide class on page load
  updateAccountLocationVisibility();
  
  // Listen for cart events to update visibility
  document.addEventListener('cart:open', function() {
    updateAccountLocationVisibility();
    ensureCartDrawerLogo();
  });
  document.addEventListener('cart:close', updateAccountLocationVisibility);
  
  // Also listen for cart updates (when items are added/removed)
  document.addEventListener('cart:updated', ensureCartDrawerLogo);
  
  // Cart button text management - separated concerns
  const cartButton = document.getElementById('cart-icon-bubble');
  let currentCartCount = 0; // Current cart count (always kept up to date)
  
  // Function to check if cart drawer is open
 // Function to check if cart drawer is open
  function isCartDrawerOpen() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return false;
    
    // Check .drawer__inner (cart with items)
    const drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (drawerInner) {
      const style = window.getComputedStyle(drawerInner);
      if (style.visibility !== 'hidden' && drawerInner.offsetWidth > 0) {
        return true;
      }
    }
    
    // Check .drawer__inner-empty (empty cart)
    const drawerEmpty = cartDrawer.querySelector('.drawer__inner-empty');
    if (drawerEmpty) {
      const style = window.getComputedStyle(drawerEmpty);
      if (style.visibility !== 'hidden' && drawerEmpty.offsetWidth > 0) {
        return true;
      }
    }
    
    return false;
  }
  
  // Function 1: Ensure cart button text element exists (prevents Shopify from removing it)
  function ensureCartButtonTextElement() {
    const button = document.getElementById('cart-icon-bubble');
    if (!button) return null;
    
    let text = button.querySelector('.cart-button-text');
    
    // If our custom span doesn't exist, Shopify replaced it - recreate it
    if (!text) {
      // Remove Shopify's default content (SVG icon, visually-hidden span)
      button.innerHTML = '';
      
      // Create our custom text span
      text = document.createElement('span');
      text.className = 'cart-button-text';
      button.appendChild(text);
    }
    
    return text;
  }
  
  // Function 2: Update button text based ONLY on drawer state (separate from count updates)
  function updateButtonTextFromDrawerState() {
    const text = ensureCartButtonTextElement();
    if (!text) return;
    
    const button = document.getElementById('cart-icon-bubble');
    if (!button) return;
    
    // Check drawer state and update text accordingly
    if (isCartDrawerOpen()) {
      // Drawer is open - show "Close"
      text.textContent = 'Close';
      button.setAttribute('aria-expanded', 'true');
    } else {
      // Drawer is closed - show count
      text.textContent = 'Shopping bag (' + currentCartCount + ')';
      button.setAttribute('aria-expanded', 'false');
    }
  }
  
  // Function 3: Update cart count (separate from drawer state)
  function updateCartCount(newCount) {
    currentCartCount = newCount;
    // Only update button text if drawer is closed (don't interfere with "Close" text)
    if (!isCartDrawerOpen()) {
      updateButtonTextFromDrawerState();
    }
  }
  
  if (cartButton) {
    const cartButtonText = cartButton.querySelector('.cart-button-text');
    if (cartButtonText) {
      // Initialize cart count from current button text
      const initialMatch = cartButtonText.textContent.match(/\((\d+)\)/);
      if (initialMatch) {
        currentCartCount = parseInt(initialMatch[1], 10);
      }
      
      // Handle cart updates - update count immediately and update button text
      // Handle cart updates - update count immediately
      document.addEventListener('cart:updated', function(e) {
        // Fetch fresh count from server immediately
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            currentCartCount = cart.item_count || 0;
            console.log('cart:updated - new count:', currentCartCount);
            ensureCartButtonTextElement();
            // If drawer is open, keep showing "Close", otherwise show count
            if (!isCartDrawerOpen()) {
              const text = document.querySelector('#cart-icon-bubble .cart-button-text');
              if (text) {
                text.textContent = 'Shopping bag (' + currentCartCount + ')';
              }
            }
          });
      });
      
      // Handle cart button click to toggle drawer
      cartButton.addEventListener('click', function(e) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;
        
        // Check if drawer is currently open (synchronously, before any handlers run)
        const drawerInner = cartDrawer.querySelector('.drawer__inner');
        const isOpen = drawerInner && drawerInner.style.visibility !== 'hidden' && drawerInner.getBoundingClientRect().width > 0;
        
        if (isOpen) {
          // Drawer is open - close it and prevent default behavior
          e.preventDefault();
          e.stopImmediatePropagation();
          
          // Try multiple methods to close, in order of preference:
          // 1. Click the close button (most reliable, uses same path as UI)
          const closeButton = cartDrawer.querySelector('.drawer__close');
          if (closeButton) {
            closeButton.click();
          } else if (typeof cartDrawer.close === 'function') {
            // 2. Use component's close method
            cartDrawer.close();
          } else {
            // 3. Fallback: manually hide the drawer
            if (drawerInner) {
              drawerInner.style.visibility = 'hidden';
            }
            // Dispatch close event for any listeners
            document.dispatchEvent(new CustomEvent('cart:close'));
          }
        }
        // If drawer is closed, let default behavior open it
      }, true);
      
      // Handle drawer open/close events - ONLY update button text based on drawer state
      document.addEventListener('cart:open', function() {
        setTimeout(updateButtonTextFromDrawerState, 50);
        setTimeout(updateButtonTextFromDrawerState, 150);
        // Update visibility (hides menu button on mobile)
        updateAccountLocationVisibility();
      });
      
      document.addEventListener('cart:close', function() {
      // When drawer closes, ALWAYS fetch fresh cart count from server
      // This is the most reliable way to get the correct count
      setTimeout(function() {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            currentCartCount = cart.item_count || 0;
            // Force update button text directly
            const button = document.getElementById('cart-icon-bubble');
            if (button) {
              let text = button.querySelector('.cart-button-text');
              if (!text) {
                button.innerHTML = '';
                text = document.createElement('span');
                text.className = 'cart-button-text';
                button.appendChild(text);
              }
              text.textContent = 'Shopping bag (' + currentCartCount + ')';
              button.setAttribute('aria-expanded', 'false');
            }
          })
          .catch(function(err) {
            console.log('Cart fetch error:', err);
          });
      }, 150);
      
      // Fetch again after longer delay as backup
      setTimeout(function() {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            currentCartCount = cart.item_count || 0;
            const button = document.getElementById('cart-icon-bubble');
            const text = button ? button.querySelector('.cart-button-text') : null;
            if (text && !isCartDrawerOpen()) {
              text.textContent = 'Shopping bag (' + currentCartCount + ')';
            }
          });
      }, 400);
      
      // Update visibility (shows menu button again on mobile)
      updateAccountLocationVisibility();
    });
              
      // Watch for close button clicks inside cart drawer
      const cartDrawerElement = document.querySelector('cart-drawer');
      if (cartDrawerElement) {
        cartDrawerElement.addEventListener('click', function(e) {
          if (e.target.closest('.drawer__close')) {
            // Close button was clicked - update count after drawer closes
            setTimeout(function() {
              fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                  currentCartCount = cart.item_count || 0;
                  const text = ensureCartButtonTextElement();
                  if (text) {
                    text.textContent = 'Shopping bag (' + currentCartCount + ')';
                    const button = document.getElementById('cart-icon-bubble');
                    if (button) button.setAttribute('aria-expanded', 'false');
                  }
                });
            }, 200);
          }
        });
      }
      // Watch for drawer visibility changes - ONLY update button text, don't touch count
      const cartDrawerForObserver = document.querySelector('cart-drawer');
      if (cartDrawerForObserver) {
        const drawerInner = cartDrawerForObserver.querySelector('.drawer__inner');
        if (drawerInner) {
          const observer = new MutationObserver(function() {
            updateAccountLocationVisibility();
            
            // When drawer visibility changes, fetch fresh count
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                currentCartCount = cart.item_count || 0;
                console.log('MutationObserver - drawer changed, count:', currentCartCount, 'isOpen:', isCartDrawerOpen());
                updateButtonTextFromDrawerState();
              })
              .catch(function() {
                updateButtonTextFromDrawerState();
              });
          });
          observer.observe(drawerInner, { 
            attributes: true, 
            attributeFilter: ['style', 'class']
          });
          observer.observe(cartDrawerForObserver, {
            attributes: true,
            attributeFilter: ['class']
          });
        }
        
        // Watch cart items container for instant count updates when items are added/removed
        
      }
      
      // Watch for cart button changes - if Shopify removes our text element, recreate it
      const cartButtonObserver = new MutationObserver(function() {
        const button = document.getElementById('cart-icon-bubble');
        if (button && !button.querySelector('.cart-button-text')) {
          // Shopify removed our text element - recreate it and set correct text
          ensureCartButtonTextElement();
          updateButtonTextFromDrawerState();
        }
      });
      
      if (cartButton) {
        cartButtonObserver.observe(cartButton, {
          childList: true,
          subtree: true
        });
      }
      
      // Initial setup
      ensureCartButtonTextElement();
      updateButtonTextFromDrawerState();
    }
  }
  
  // Handle backdrop clicks to close drawers
  const backdrop = document.querySelector('.drawer-backdrop');
  if (backdrop) {
    backdrop.addEventListener('click', function(e) {
      // Close menu drawer if open
      const menuDrawer = document.querySelector('header-drawer');
      if (menuDrawer) {
        const drawerDetails = menuDrawer.querySelector('details');
        const isMenuOpen = (drawerDetails && drawerDetails.hasAttribute('open')) || menuDrawer.hasAttribute('open');
        
        if (isMenuOpen && window.matchMedia('(max-width: 750px)').matches) {
          e.preventDefault();
          e.stopPropagation();
          
          // Add closing animation classes
          backdrop.classList.add('menu-closing');
          menuDrawer.classList.add('menu-closing');
          
          // Close menu drawer
          const duration = 300; // 0.3s in milliseconds
          setTimeout(function() {
            if (typeof menuDrawer.close === 'function') {
              menuDrawer.close();
            } else if (drawerDetails) {
              drawerDetails.removeAttribute('open');
              menuDrawer.removeAttribute('open');
            }
            
            // Remove closing classes
            menuDrawer.classList.remove('menu-closing');
            backdrop.classList.remove('menu-closing');
            
            // Update menu button text
            const menuButtonText = document.querySelector('.menu-button-text');
            if (menuButtonText) {
              menuButtonText.textContent = 'Menu';
            }
          }, duration);
          return;
        }
      }
      
      // Close cart drawer if open
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && isCartDrawerOpen()) {
        e.preventDefault();
        e.stopPropagation();
        
        // Add closing animation classes
        backdrop.classList.add('cart-closing');
        cartDrawer.classList.add('cart-closing');
        
        // Close cart drawer
        const duration = 300; // 0.3s in milliseconds
        setTimeout(function() {
          const closeButton = cartDrawer.querySelector('.drawer__close');
          if (closeButton) {
            closeButton.click();
          } else if (typeof cartDrawer.close === 'function') {
            cartDrawer.close();
          } else {
            const drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) {
              drawerInner.style.visibility = 'hidden';
            }
            document.dispatchEvent(new CustomEvent('cart:close'));
          }
          
          // Remove closing classes
          cartDrawer.classList.remove('cart-closing');
          backdrop.classList.remove('cart-closing');
        }, duration);
      }
    });
  }

  // Add click-outside-to-close for cart drawer (like menu drawer)
  document.addEventListener('click', function(e) {
    const cartDrawerForClick = document.querySelector('cart-drawer');
    if (cartDrawerForClick && isCartDrawerOpen()) {
      const cartButtonForClick = document.getElementById('cart-icon-bubble');
      const backdropForClick = document.querySelector('.drawer-backdrop');
      const isClickInsideCart = cartDrawerForClick.contains(e.target) || 
                                (cartButtonForClick && cartButtonForClick.contains(e.target)) ||
                                (backdropForClick && backdropForClick.contains(e.target));
      
      if (!isClickInsideCart) {
        // Add closing animation class
        if (cartDrawerForClick && window.matchMedia('(max-width: 750px)').matches) {
          cartDrawerForClick.classList.add('cart-closing');
          if (backdropForClick) {
            backdropForClick.classList.add('cart-closing');
          }
        }
        
        const duration = 300; // 0.3s
        setTimeout(function() {
          const closeButton = cartDrawerForClick.querySelector('.drawer__close');
          if (closeButton) {
            closeButton.click();
          } else if (typeof cartDrawerForClick.close === 'function') {
            cartDrawerForClick.close();
          } else {
            const drawerInner = cartDrawerForClick.querySelector('.drawer__inner');
            if (drawerInner) {
              drawerInner.style.visibility = 'hidden';
            }
            document.dispatchEvent(new CustomEvent('cart:close'));
          }
          
          // Remove closing classes
          cartDrawerForClick.classList.remove('cart-closing');
          if (backdropForClick) {
            backdropForClick.classList.remove('cart-closing');
          }
        }, duration);
      }
    }
  });
});
} catch (error) {
  console.error('Error in DOMContentLoaded handler:', error);
}

